(function () {
  'use strict';
  if (window.PedalInsiderBagJoin) return;
  if (typeof fetch !== 'function' || typeof Promise === 'undefined') return;

  var tag = document.currentScript || document.querySelector('script[data-ibb-join]');
  var CODE_RE = /^[A-Za-z0-9][A-Za-z0-9-]{2,38}[A-Za-z0-9]$/;
  var CODE = tag ? String(tag.getAttribute('data-code') || '').trim() : '';
  var UPGRADE = tag ? String(tag.getAttribute('data-upgrade') || '').trim() : '';
  var VIEW = tag && !CODE ? String(tag.getAttribute('data-view') || '').trim() : '';
  if (!/^[0-9]{5,20}$/.test(UPGRADE)) return;
  if (CODE) {
    if (!CODE_RE.test(CODE)) return;
  } else if (!/^\/cart\?view=[a-z0-9-]{1,40}$/.test(VIEW)) {
    return;
  }
  var OURS = CODE.toUpperCase();
  var viewReads = 0;

  var running = null;
  var again = false;
  var timer = null;
  var notApplicable = {};

  function request(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r && r.ok ? r.json() : null; });
  }

  function hasBundle(cart) {
    return (cart.items || []).some(function (item) {
      return String(item.product_id) === UPGRADE && !!(item.properties && item.properties._insider_bundle);
    });
  }

  var KIT_HANDLES = ['insider-included', 'insider-kit-team-included'];

  function hasKit(cart) {
    return (cart.items || []).some(function (item) {
      return KIT_HANDLES.indexOf(String(item.handle)) > -1 && !(item.properties && item.properties._insider_bundle);
    });
  }

  function signature(cart) {
    return (cart.items || []).map(function (item) { return item.key + ':' + item.quantity; }).join('|');
  }

  function codesOf(cart) {
    return (cart.discount_codes || []).map(function (c) {
      return { code: String(c.code || ''), applicable: !!c.applicable };
    });
  }

  function isOurs(code) {
    return code.toUpperCase() === OURS;
  }

  function teamIdle() {
    var team = window.PedalTeamCode;
    if (!team || typeof team.sync !== 'function') return Promise.resolve();
    return Promise.resolve().then(function () { return team.sync(); }).catch(function () { return null; });
  }

  function setCodes(list) {
    return request('/cart/update.js', { discount: list.join(',') });
  }

  function refreshed(cart) {
    if (!cart) return cart;
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    return cart;
  }

  function readView() {
    return fetch(VIEW, { method: 'GET', credentials: 'same-origin' }).then(function (r) { return r && r.ok ? r.json() : null; });
  }

  function learn(cart) {
    if (CODE) return Promise.resolve(true);
    if (!hasBundle(cart) && !hasKit(cart) && !(cart.discount_codes || []).length) return Promise.resolve(false);
    if (viewReads >= 3) return Promise.resolve(false);
    viewReads += 1;
    return readView().catch(function () { return null; }).then(function (answer) {
      var got = answer && typeof answer.code === 'string' ? answer.code.trim() : '';
      if (!CODE_RE.test(got)) return false;
      CODE = got;
      OURS = CODE.toUpperCase();
      return true;
    });
  }

  function sync() {
    return teamIdle().then(function () { return request('/cart.js'); }).then(function (cart) {
      if (!cart || !cart.items) return cart;
      return learn(cart).then(function (known) { return known ? act(cart) : cart; });
    });
  }

  function act(cart) {
    var current = codesOf(cart);
    var others = current.filter(function (c) { return !isOurs(c.code); }).map(function (c) { return c.code; });
    var ours = current.filter(function (c) { return isOurs(c.code); });
    var sig = signature(cart);

    if (!hasBundle(cart) && !hasKit(cart)) {
      if (!ours.length) return cart;
      return setCodes(others).then(refreshed);
    }
    if (ours.length) {
      if (ours.some(function (c) { return c.applicable; })) return cart;
      notApplicable[sig] = true;
      return setCodes(others).then(refreshed);
    }
    if (notApplicable[sig]) return cart;

    return setCodes(others.concat([CODE])).then(function (updated) {
      if (!updated) return updated;
      var mine = codesOf(updated).filter(function (c) { return isOurs(c.code); });
      if (!mine.some(function (c) { return c.applicable; })) {
        notApplicable[sig] = true;
        notApplicable[signature(updated)] = true;
        return setCodes(others).then(refreshed);
      }
      return refreshed(updated);
    });
  }

  function run() {
    if (running) {
      again = true;
      return running;
    }
    running = sync()
      .catch(function () { return null; })
      .then(function (cart) {
        running = null;
        if (again) {
          again = false;
          schedule();
        }
        return cart;
      });
    return running;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 250);
  }

  ['cart:updated', 'cart:build', 'cart:open', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule();
  });

  window.PedalInsiderBagJoin = { sync: run };
  schedule();
})();
